import { render, staticRenderFns } from "./tab5.vue?vue&type=template&id=07c23bb6&scoped=true&"
import script from "./tab5.vue?vue&type=script&lang=js&"
export * from "./tab5.vue?vue&type=script&lang=js&"
import style0 from "./tab5.vue?vue&type=style&index=0&id=07c23bb6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c23bb6",
  null
  
)

export default component.exports